// import React from 'react'
// import { useNavigate } from 'react-router-dom';     
// function NextAudit() {
//   const navigate = useNavigate();
//   const auditID = localStorage.getItem('auditID');
//   navigate(`/nextcamera/${auditID}`)
//   return (
//     <div>NextAudit</div>
//   )
// }

// export default NextAudit
// import React from 'react';
// import { useNavigate, useParams } from 'react-router-dom';

// function NextAudit() {
//   const navigate = useNavigate();
//   const { audit_id } = useParams(); // get from URL

//   const handleProceed = () => {
//     navigate(`/nextcamera/${audit_id}`);
//   };

//   return (
//     <div
//       style={{
//         height: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         gap: '20px'
//       }}
//     >
//       <h2>Starting inspection for {audit_id}</h2>

//       <button
//         onClick={handleProceed}
//         style={{
//           padding: '10px 24px',
//           fontSize: '16px',
//           cursor: 'pointer',
//         }}
//       >
//         Proceed
//       </button>
//     </div>
//   );
// }

// export default NextAudit;
// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';

// function NextAudit() {

//   const navigate = useNavigate();
//   const { audit_id } = useParams();

//   const [nextAudit, setNextAudit] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // you can get this from localStorage / context / redux
//   const userID = localStorage.getItem("userID");

//   useEffect(() => {

//     const fetchPendingAudits = async () => {

//       try {

//         const response = await fetch("/api/validate-token/pending-audits", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json"
//           },
//           body: JSON.stringify({
//             audit_id,
//             userID
//           })
//         });

//         const data = await response.json();

//         if (data.success) {
//           setNextAudit(data.nextAudit);
//         }

//       } catch (error) {
//         console.error("Error fetching next audit:", error);
//       }
//       finally {
//         setLoading(false);
//       }

//     };

//     fetchPendingAudits();

//   }, [audit_id, userID]);



//   const handleProceed = () => {

//     if (nextAudit) {
//       navigate(`/nextcamera/${nextAudit}`);
//     } else {
//       alert("No pending audits left");
//     }

//   };



//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: "40vh" }}>
//         Loading next audit...
//       </div>
//     );
//   }



//   return (
//     <div
//       style={{
//         height: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         gap: '20px'
//       }}
//     >

//       <h2>
//         {nextAudit
//           ? `Starting inspection for ${nextAudit}`
//           : "No pending inspections left"}
//       </h2>

//       {nextAudit && (
//         <button
//           onClick={handleProceed}
//           style={{
//             padding: '10px 24px',
//             fontSize: '16px',
//             cursor: 'pointer',
//           }}
//         >
//           Proceed
//         </button>
//       )}

//     </div>
//   );

// }

// export default NextAudit;
// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';

// function NextAudit() {

//   const navigate = useNavigate();
//   const { audit_id } = useParams();

//   const [nextAudit, setNextAudit] = useState(null);
//   const [loading, setLoading] = useState(true);

// const storedUser = localStorage.getItem("insuranceUser");

// const userID = storedUser ? JSON.parse(storedUser).userId : null;

//   useEffect(() => {

//     const fetchPendingAudits = async () => {

//       try {

//         const response = await fetch("/process_data/tokenpendingaudits", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json"
//           },
//           body: JSON.stringify({
//             audit_id,
//             userID
//           })
//         });

//         const data = await response.json();

//         if (data.success) {
//           setNextAudit(data.nextAudit); // will be null if none left
//         }
//        console.log(data.nextAudit,"next audit");
//       } catch (error) {
//         console.error("Error fetching next audit:", error);
//       }
//       finally {
//         setLoading(false);
//       }

//     };

//     fetchPendingAudits();

//   }, [audit_id, userID]);



//   const handleProceed = () => {

//     if (nextAudit) {

//       // go to next inspection
// navigate(`/nextcamera/${data.nextAudit}`) // correct value

//     } else {

//       // all audits completed → go to processing page
//       navigate(`/processing/${audit_id}`);

//     }

//   };



//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: "40vh" }}>
//         Loading...
//       </div>
//     );
//   }



//   return (
//     <div
//       style={{
//         height: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         gap: '20px'
//       }}
//     >

//       <h2>
//         {nextAudit
//           ? `Starting inspection for ${nextAudit}`
//           : "All inspections completed"}
//       </h2>

//       <button
//         onClick={handleProceed}
//         style={{
//           padding: '10px 24px',
//           fontSize: '16px',
//           cursor: 'pointer',
//         }}
//       >
//         {nextAudit ? "Proceed" : "Go to Processing"}
//       </button>

//     </div>
//   );

// }

// export default NextAudit;
// import React from "react";
// import { useNavigate, useParams } from "react-router-dom";

// function NextAudit() {

//   const navigate = useNavigate();
//   const { audit_id } = useParams();

//   const handleProceed = async () => {

//     try {

//       const user = JSON.parse(localStorage.getItem("insuranceUser"));

//       if (!user?.userId) {
//         alert("User not found");
//         return;
//       }

//       const response = await fetch("/process_data/tokenpendingaudits", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           audit_id,
//           userID: user.userId
//         })
//       });

//       const data = await response.json();

//       console.log("Next audit:", data.nextAudit);

//       if (data.nextAudit) {
//         navigate(`/nextcamera/${data.nextAudit}`);
//       } else {
//         alert("No pending audits");
//       }

//     } catch (err) {
//       console.error(err);
//     }

//   };

//   return (
//     <div>

//       <h2>{audit_id}</h2>

//       <button onClick={handleProceed}>
//         Proceed
//       </button>

//     </div>
//   );

// }

// export default NextAudit;
// import React, { useEffect } from "react"; // Add useEffect import
// import { useNavigate, useParams } from "react-router-dom";
// import { setAuditID } from "../store/images"; // <-- adjust import
// import { useDispatch } from "react-redux";
// function NextAudit() {
//   const navigate = useNavigate();
//   const { audit_id } = useParams();
//   const dispatch = useDispatch();
//   // Clear any cached data or context before proceeding
//   useEffect(() => {
//     // Clear localStorage cache for previous audit
//     const keysToRemove = [];
//     for (let i = 0; i < localStorage.length; i++) {
//       const key = localStorage.key(i);
//       if (key.includes('image-cache') || key.includes('cattle num')) {
//         keysToRemove.push(key);
//       }
//     }
//     keysToRemove.forEach(key => localStorage.removeItem(key));

//     // Clear service worker cache if exists
//     if ('caches' in window) {
//       caches.keys().then(cacheNames => {
//         cacheNames.forEach(cacheName => {
//           if (cacheName.includes('image-cache')) {
//             caches.delete(cacheName);
//           }
//         });
//       });
//     }
//   }, []);

//   const handleProceed = async () => {
//     try {
//       const user = JSON.parse(localStorage.getItem("insuranceUser"));

//       if (!user?.userId) {
//         alert("User not found");
//         return;
//       }

//       const response = await fetch("/process_data/tokenpendingaudits", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           audit_id,
//           userID: user.userId
//         })
//       });

//       const data = await response.json();

//       console.log("Next audit:", data.nextAudit);
//        const nextAudit = data.nextAudit;
//       if (nextAudit) {
//         dispatch(setAuditID(nextAudit));

//         // ✅ SPA navigation so redux persists
//         navigate(`/nextcamera/${nextAudit}`, { replace: true });
//       } else {
//         alert("No pending audits");
//         window.location.href = `/auditList`;
//       }

//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <div>
//       <h2>Done Audit ID: {audit_id}</h2>
//       <button onClick={handleProceed} style={{ padding: '10px 24px', fontSize: '16px', cursor: 'pointer', color: 'white', backgroundColor: '#007BFF', border: 'none', borderRadius: '4px' }}>
//         Proceed to Next Audit
//       </button>
//     </div>
//   );
// }

// export default NextAudit;
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { setAuditID } from "../store/images"; // adjust if needed
// import { useDispatch } from "react-redux";

// function NextAudit() {
//   const navigate = useNavigate();
//   const { audit_id } = useParams();
//   const dispatch = useDispatch();
// const [done, setDone] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [nextAuditId, setNextAuditId] = useState(null);
//   const [error, setError] = useState("");

//   // Clear cached data / previous audit artefacts
//   useEffect(() => {
//     try {
//       const keysToRemove = [];
//       for (let i = 0; i < localStorage.length; i++) {
//         const key = localStorage.key(i);
//         if (!key) continue;
//         if (key.includes("image-cache") || key.includes("cattle num")) {
//           keysToRemove.push(key);
//         }
//       }
//       keysToRemove.forEach((key) => localStorage.removeItem(key));

//       if ("caches" in window) {
//         caches.keys().then((cacheNames) => {
//           cacheNames.forEach((cacheName) => {
//             if (cacheName.includes("image-cache")) caches.delete(cacheName);
//           });
//         });
//       }
//     } catch (e) {
//       // don’t block UI if cache clear fails
//       console.warn("Cache clear failed:", e);
//     }
//   }, []);

//   const handleProceed = async () => {
//     setError("");
//     setLoading(true);

//     try {
//       const user = JSON.parse(localStorage.getItem("insuranceUser"));
//       if (!user?.userId) {
//         setError("User not found. Please login again.");
//         setLoading(false);
//         return;
//       }

//       const response = await fetch("/process_data/tokenpendingaudits", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           audit_id,
//           userID: user.userId,
//         }),
//       });

//       const data = await response.json();
//       const nextAudit = data?.nextAudit || null;

//       setNextAuditId(nextAudit);

//       if (nextAudit) {
//         dispatch(setAuditID(nextAudit));
//         navigate(`/nextcamera/${nextAudit}`, { replace: true });
//       } else {
//         setDone(true);

//         // redirect after short delay
//         setTimeout(() => {
//           navigate("/auditList", { replace: true });
//         }, 2000);
//         // All done → back to list (SPA navigation preferred)
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong while fetching next audit. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.page}>
//       <div style={styles.card}>
//         <div style={styles.badge}>Inspection</div>

//         <h1 style={styles.title}>Audit Completed</h1>
//         <p style={styles.subtitle}>
//           Finished audit <span style={styles.mono}>{audit_id}</span>
//         </p>

//         <div style={styles.divider} />

//         {error ? (
//           <div style={styles.errorBox}>
//             <div style={styles.errorTitle}>Couldn’t proceed</div>
//             <div style={styles.errorText}>{error}</div>
//           </div>
//         ) : (
//           <div style={styles.infoBox}>
//             <div style={styles.infoLabel}>Next step</div>
//             <div style={styles.infoText}>
//               Tap <b>Proceed</b> to move to the next pending audit.
//             </div>
//           </div>
//         )}

//         {nextAuditId && (
//           <div style={styles.nextAuditRow}>
//             <span style={styles.nextAuditLabel}>Next audit</span>
//             <span style={styles.mono}>{nextAuditId}</span>
//           </div>
//         )}

//         <button
//           onClick={handleProceed}
//           disabled={loading}
//           style={{
//             ...styles.button,
//             ...(loading ? styles.buttonDisabled : {}),
//           }}
//         >
//           {loading ? (
//             <span style={styles.buttonRow}>
//               <span style={styles.spinner} />
//               Loading...
//             </span>
//           ) : (
//             <span style={styles.buttonRow}>
//               Proceed to Next Audit
//               <span style={styles.arrow}>→</span>
//             </span>
//           )}
//         </button>

//         <button
//           onClick={() => navigate("/auditList")}
//           disabled={loading}
//           style={styles.secondaryBtn}
//         >
//           Back to Audit List
//         </button>

//         <div style={styles.footerNote}>
//           Tip: If you left mid-way earlier, we’ll continue from where you stopped.
//         </div>
//       </div>
//     </div>
//   );
// }

// export default NextAudit;

// const styles = {
//   page: {
//     minHeight: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "18px",
//     background:
//       "radial-gradient(1200px 600px at 10% 10%, rgba(252,53,11,0.14), transparent 60%), radial-gradient(900px 500px at 90% 20%, rgba(0,123,255,0.12), transparent 55%), #0B0F1A",
//     fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
//   },
//   card: {
//     width: "100%",
//     maxWidth: "420px",
//     borderRadius: "18px",
//     padding: "20px",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.12)",
//     boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
//     color: "#fff",
//     backdropFilter: "blur(10px)",
//   },
//   badge: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "8px",
//     fontSize: "12px",
//     fontWeight: 700,
//     letterSpacing: "0.4px",
//     color: "#FFB4A6",
//     background: "rgba(252,53,11,0.12)",
//     border: "1px solid rgba(252,53,11,0.22)",
//     padding: "6px 10px",
//     borderRadius: "999px",
//     marginBottom: "12px",
//   },
//   title: {
//     margin: 0,
//     fontSize: "22px",
//     lineHeight: 1.2,
//   },
//   subtitle: {
//     margin: "6px 0 0",
//     fontSize: "13px",
//     opacity: 0.85,
//   },
//   mono: {
//     fontFamily:
//       "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
//     fontSize: "12px",
//     padding: "2px 6px",
//     borderRadius: "8px",
//     background: "rgba(255,255,255,0.08)",
//     border: "1px solid rgba(255,255,255,0.10)",
//   },
//   divider: {
//     height: "1px",
//     background: "rgba(255,255,255,0.12)",
//     margin: "14px 0",
//   },
//   infoBox: {
//     borderRadius: "14px",
//     padding: "12px",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.10)",
//     marginBottom: "12px",
//   },
//   infoLabel: {
//     fontSize: "12px",
//     opacity: 0.8,
//     marginBottom: "4px",
//   },
//   infoText: {
//     fontSize: "13px",
//     lineHeight: 1.4,
//     opacity: 0.95,
//   },
//   nextAuditRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "10px 12px",
//     borderRadius: "14px",
//     background: "rgba(0,123,255,0.10)",
//     border: "1px solid rgba(0,123,255,0.20)",
//     marginBottom: "12px",
//   },
//   nextAuditLabel: {
//     fontSize: "12px",
//     opacity: 0.9,
//   },
//   errorBox: {
//     borderRadius: "14px",
//     padding: "12px",
//     background: "rgba(255, 68, 68, 0.10)",
//     border: "1px solid rgba(255, 68, 68, 0.22)",
//     marginBottom: "12px",
//   },
//   errorTitle: {
//     fontSize: "13px",
//     fontWeight: 700,
//     marginBottom: "4px",
//   },
//   errorText: {
//     fontSize: "13px",
//     lineHeight: 1.4,
//     opacity: 0.95,
//   },
//   button: {
//     width: "100%",
//     border: "none",
//     borderRadius: "14px",
//     padding: "12px 14px",
//     fontSize: "14px",
//     fontWeight: 700,
//     color: "#fff",
//     background: "linear-gradient(135deg, #007BFF, #4DA3FF)",
//     cursor: "pointer",
//     boxShadow: "0 14px 30px rgba(0,123,255,0.22)",
//     transition: "transform 120ms ease, opacity 120ms ease",
//   },
//   buttonDisabled: {
//     opacity: 0.7,
//     cursor: "not-allowed",
//   },
//   buttonRow: {
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "10px",
//   },
//   arrow: {
//     fontSize: "16px",
//     opacity: 0.9,
//   },
//   secondaryBtn: {
//     width: "100%",
//     marginTop: "10px",
//     borderRadius: "14px",
//     padding: "11px 14px",
//     fontSize: "13px",
//     fontWeight: 700,
//     color: "rgba(255,255,255,0.92)",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.12)",
//     cursor: "pointer",
//   },
//   footerNote: {
//     marginTop: "12px",
//     fontSize: "12px",
//     opacity: 0.7,
//     lineHeight: 1.35,
//   },
//   spinner: {
//     width: "14px",
//     height: "14px",
//     borderRadius: "50%",
//     border: "2px solid rgba(255,255,255,0.35)",
//     borderTopColor: "rgba(255,255,255,0.95)",
//     animation: "spin 0.9s linear infinite",
//   },
// };
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setAuditID } from "../store/images"; // adjust if needed
import { useDispatch } from "react-redux";

function NextAudit() {
  const navigate = useNavigate();
  const { audit_id } = useParams();
  const dispatch = useDispatch();

  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nextAuditId, setNextAuditId] = useState(null);
  const [error, setError] = useState("");

  // Clear cached data / previous audit artefacts
  useEffect(() => {
    try {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        if (key.includes("image-cache") || key.includes("cattle num")) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach((key) => localStorage.removeItem(key));

      if ("caches" in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => {
            if (cacheName.includes("image-cache")) caches.delete(cacheName);
          });
        });
      }
    } catch (e) {
      console.warn("Cache clear failed:", e);
    }
  }, []);

  const handleProceed = async () => {
    // If already done, just go to list
    if (done) {
      navigate("/auditList", { replace: true });
      return;
    }

    setError("");
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("insuranceUser"));
      if (!user?.userId) {
        setError("User not found. Please login again.");
        setLoading(false);
        return;
      }

      const response = await fetch("/process_data/tokenpendingaudits", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          audit_id,
          userID: user.userId,
        }),
      });

      const data = await response.json();
      const nextAudit = data?.nextAudit || null;

      setNextAuditId(nextAudit);

      if (nextAudit) {
        dispatch(setAuditID(nextAudit));
        navigate(`/nextcamera/${nextAudit}`, { replace: true });
      } else {
        setDone(true);

        // redirect after short delay
        setTimeout(() => {
          navigate("/auditList", { replace: true });
        }, 2000);
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong while fetching next audit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.badge}>Inspection</div>

        <h1 style={styles.title}>{done ? "All Audits Completed" : "Audit Completed"}</h1>
        <p style={styles.subtitle}>
          Finished audit <span style={styles.mono}>{audit_id}</span>
        </p>

        <div style={styles.divider} />

        {/* STATUS BOX */}
        {error ? (
          <div style={styles.errorBox}>
            <div style={styles.errorTitle}>Couldn’t proceed</div>
            <div style={styles.errorText}>{error}</div>
          </div>
        ) : done ? (
          <div style={styles.successBox}>
            <div style={styles.successTitle}>No pending audits left</div>
            <div style={styles.successText}>
              You’re done. Redirecting to Audit List…
            </div>
          </div>
        ) : (
          <div style={styles.infoBox}>
            <div style={styles.infoLabel}>Next step</div>
            <div style={styles.infoText}>
              Tap <b>Proceed</b> to move to the next pending audit.
            </div>
          </div>
        )}

        {/* NEXT AUDIT ROW (only when not done) */}
        {!done && nextAuditId && (
          <div style={styles.nextAuditRow}>
            <span style={styles.nextAuditLabel}>Next audit</span>
            <span style={styles.mono}>{nextAuditId}</span>
          </div>
        )}

        {/* PRIMARY BUTTON */}
        <button
          onClick={handleProceed}
          disabled={loading}
          style={{
            ...styles.button,
            ...(loading ? styles.buttonDisabled : {}),
          }}
        >
          {loading ? (
            <span style={styles.buttonRow}>
              <span style={styles.spinner} />
              Loading...
            </span>
          ) : (
            <span style={styles.buttonRow}>
              {done ? "Go to Audit List" : "Proceed to Next Audit"}
              <span style={styles.arrow}>→</span>
            </span>
          )}
        </button>

        {/* SECONDARY BUTTON */}
        <button
          onClick={() => navigate("/auditList")}
          disabled={loading}
          style={styles.secondaryBtn}
        >
          Back to Audit List
        </button>

        {/* <div style={styles.footerNote}>
          {done
            ? "You can start a new inspection anytime from the list."
            : "If you left mid-way earlier, we’ll continue from where you stopped."}
        </div> */}
      </div>
    </div>
  );
}

export default NextAudit;
const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "18px",
    background: "#ffffff",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "420px",
    borderRadius: "18px",
    padding: "24px",
    background: "#ffffff",
    border: "1px solid #F2F2F2",
    boxShadow: "0 10px 30px rgba(252,53,11,0.08)",
    color: "#222",
  },

  badge: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.4px",
    color: "#FC350B",
    background: "rgba(252,53,11,0.08)",
    border: "1px solid rgba(252,53,11,0.2)",
    padding: "6px 12px",
    borderRadius: "999px",
    marginBottom: "14px",
  },

  title: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 700,
    color: "#FC350B",
  },

  subtitle: {
    margin: "6px 0 0",
    fontSize: "13px",
    color: "#666",
  },

  mono: {
    fontFamily:
      "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: "12px",
    padding: "2px 6px",
    borderRadius: "6px",
    background: "rgba(252,53,11,0.08)",
    color: "#FC350B",
  },

  divider: {
    height: "1px",
    background: "#F0F0F0",
    margin: "18px 0",
  },

  infoBox: {
    borderRadius: "14px",
    padding: "14px",
    background: "#fff",
    border: "1px solid #F2F2F2",
    marginBottom: "14px",
  },

  infoLabel: {
    fontSize: "12px",
    color: "#FC350B",
    fontWeight: 600,
    marginBottom: "4px",
  },

  infoText: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#444",
  },

  successBox: {
    borderRadius: "14px",
    padding: "14px",
    background: "rgba(252,53,11,0.05)",
    border: "1px solid rgba(252,53,11,0.2)",
    marginBottom: "14px",
  },

  successTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#FC350B",
    marginBottom: "4px",
  },

  successText: {
    fontSize: "13px",
    color: "#555",
  },

  errorBox: {
    borderRadius: "14px",
    padding: "14px",
    background: "rgba(252,53,11,0.05)",
    border: "1px solid rgba(252,53,11,0.25)",
    marginBottom: "14px",
  },

  errorTitle: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#FC350B",
    marginBottom: "4px",
  },

  errorText: {
    fontSize: "13px",
    color: "#444",
  },

  nextAuditRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    borderRadius: "12px",
    background: "rgba(252,53,11,0.05)",
    border: "1px solid rgba(252,53,11,0.2)",
    marginBottom: "14px",
  },

  nextAuditLabel: {
    fontSize: "12px",
    color: "#FC350B",
    fontWeight: 600,
  },

  button: {
    width: "100%",
    border: "none",
    borderRadius: "14px",
    padding: "13px 16px",
    fontSize: "14px",
    fontWeight: 700,
    color: "#ffffff",
    background: "#FC350B",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 8px 20px rgba(252,53,11,0.25)",
  },

  buttonDisabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },

  buttonRow: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },

  arrow: {
    fontSize: "16px",
  },

  secondaryBtn: {
    width: "100%",
    marginTop: "12px",
    borderRadius: "14px",
    padding: "12px 14px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#FC350B",
    background: "#ffffff",
    border: "1px solid #FC350B",
    cursor: "pointer",
  },

  footerNote: {
    marginTop: "14px",
    fontSize: "12px",
    color: "#777",
    lineHeight: 1.4,
    textAlign: "center",
  },

  spinner: {
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.4)",
    borderTopColor: "#ffffff",
    animation: "spin 0.9s linear infinite",
  },
};

// const styles = {
//   page: {
//     minHeight: "100vh",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "18px",
//     background:
//       "radial-gradient(1200px 600px at 10% 10%, rgba(252,53,11,0.14), transparent 60%), radial-gradient(900px 500px at 90% 20%, rgba(0,123,255,0.12), transparent 55%), #0B0F1A",
//     fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
//   },
//   card: {
//     width: "100%",
//     maxWidth: "420px",
//     borderRadius: "18px",
//     padding: "20px",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.12)",
//     boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
//     color: "#fff",
//     backdropFilter: "blur(10px)",
//   },
//   badge: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "8px",
//     fontSize: "12px",
//     fontWeight: 700,
//     letterSpacing: "0.4px",
//     color: "#FFB4A6",
//     background: "rgba(252,53,11,0.12)",
//     border: "1px solid rgba(252,53,11,0.22)",
//     padding: "6px 10px",
//     borderRadius: "999px",
//     marginBottom: "12px",
//   },
//   title: {
//     margin: 0,
//     fontSize: "22px",
//     lineHeight: 1.2,
//   },
//   subtitle: {
//     margin: "6px 0 0",
//     fontSize: "13px",
//     opacity: 0.85,
//   },
//   mono: {
//     fontFamily:
//       "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
//     fontSize: "12px",
//     padding: "2px 6px",
//     borderRadius: "8px",
//     background: "rgba(255,255,255,0.08)",
//     border: "1px solid rgba(255,255,255,0.10)",
//   },
//   divider: {
//     height: "1px",
//     background: "rgba(255,255,255,0.12)",
//     margin: "14px 0",
//   },
//   infoBox: {
//     borderRadius: "14px",
//     padding: "12px",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.10)",
//     marginBottom: "12px",
//   },
//   infoLabel: {
//     fontSize: "12px",
//     opacity: 0.8,
//     marginBottom: "4px",
//   },
//   infoText: {
//     fontSize: "13px",
//     lineHeight: 1.4,
//     opacity: 0.95,
//   },
//   successBox: {
//     borderRadius: "14px",
//     padding: "12px",
//     background: "rgba(34,197,94,0.10)",
//     border: "1px solid rgba(34,197,94,0.22)",
//     marginBottom: "12px",
//   },
//   successTitle: {
//     fontSize: "13px",
//     fontWeight: 800,
//     marginBottom: "4px",
//   },
//   successText: {
//     fontSize: "13px",
//     lineHeight: 1.4,
//     opacity: 0.95,
//   },
//   nextAuditRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "10px 12px",
//     borderRadius: "14px",
//     background: "rgba(0,123,255,0.10)",
//     border: "1px solid rgba(0,123,255,0.20)",
//     marginBottom: "12px",
//   },
//   nextAuditLabel: {
//     fontSize: "12px",
//     opacity: 0.9,
//   },
//   errorBox: {
//     borderRadius: "14px",
//     padding: "12px",
//     background: "rgba(255, 68, 68, 0.10)",
//     border: "1px solid rgba(255, 68, 68, 0.22)",
//     marginBottom: "12px",
//   },
//   errorTitle: {
//     fontSize: "13px",
//     fontWeight: 700,
//     marginBottom: "4px",
//   },
//   errorText: {
//     fontSize: "13px",
//     lineHeight: 1.4,
//     opacity: 0.95,
//   },
//   button: {
//     width: "100%",
//     border: "none",
//     borderRadius: "14px",
//     padding: "12px 14px",
//     fontSize: "14px",
//     fontWeight: 700,
//     color: "#fff",
//     background: "linear-gradient(135deg, #007BFF, #4DA3FF)",
//     cursor: "pointer",
//     boxShadow: "0 14px 30px rgba(0,123,255,0.22)",
//     transition: "transform 120ms ease, opacity 120ms ease",
//   },
//   buttonDisabled: {
//     opacity: 0.7,
//     cursor: "not-allowed",
//   },
//   buttonRow: {
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "10px",
//   },
//   arrow: {
//     fontSize: "16px",
//     opacity: 0.9,
//   },
//   secondaryBtn: {
//     width: "100%",
//     marginTop: "10px",
//     borderRadius: "14px",
//     padding: "11px 14px",
//     fontSize: "13px",
//     fontWeight: 700,
//     color: "rgba(255,255,255,0.92)",
//     background: "rgba(255,255,255,0.06)",
//     border: "1px solid rgba(255,255,255,0.12)",
//     cursor: "pointer",
//   },
//   footerNote: {
//     marginTop: "12px",
//     fontSize: "12px",
//     opacity: 0.7,
//     lineHeight: 1.35,
//   },
//   spinner: {
//     width: "14px",
//     height: "14px",
//     borderRadius: "50%",
//     border: "2px solid rgba(255,255,255,0.35)",
//     borderTopColor: "rgba(255,255,255,0.95)",
//     animation: "spin 0.9s linear infinite",
//   },
// };
